<script setup lang="ts">
import { AppInput } from '@shared/ui/inputs'

import {
  useInputActivationDuration,
} from '../../../../model/additional-info/support/info-manual-activation/input-activation-duration.hook'

defineOptions({
  name: 'InputActivationDuration',
})

const {
  inputType,
  model,
  placeholder,
} = useInputActivationDuration()
</script>

<template>
  <AppInput
    v-model="model"
    :type="inputType"
    :placeholder="placeholder"
  />
</template>
